var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cover-image-item" }, [
    _c("input", {
      ref: "fileInput",
      staticStyle: { display: "none" },
      attrs: { type: "file", accept: "image/*" },
      on: { change: _vm.handleFileChange },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.uploading,
            expression: "uploading",
          },
        ],
        staticClass: "image-preview",
        class: { "has-image": _vm.imageUrl },
        on: { click: _vm.handleImageClick },
      },
      [
        _vm.imageUrl
          ? _c("img", {
              staticClass: "gift-card-image",
              attrs: { src: _vm.imageUrl, alt: "上传图片" },
            })
          : _c("div", { staticClass: "image-placeholder" }, [
              _c("i", { staticClass: "el-icon-plus uploader-icon" }),
              _vm._v(" "),
              _c("p", [_vm._v("点击上传")]),
            ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }